import png1 from "./1.jpg";
import png2 from "./2.jpg";
export const gpgfyh = [
  {
    name: "查找流水",
    msgList: [{ msg: "登录广发银行APP->搜索【流水证明】" }, { imgs: [png1] }],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "选择【近一年】->选择【展示交易对手信息】、【展示完整卡号】->填写专属邮箱【提交】",
      },
      { imgs: [png2] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "注意事项:交易对手信息、完整卡号信息必须打开并【展示】，否则会影响额度评估",
      },
    ],
  },
];
